import type { FC, ThHTMLAttributes } from 'react';

export type THeadCellProps = ThHTMLAttributes<HTMLHeadingElement> & {
  width?: number;
};

export const THeadCell: FC<THeadCellProps> = ({ children, width, ...props }) => {
  return (
    <th {...props} style={{ ...props.style, width }}>
      <div
        style={{
          height: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          verticalAlign: 'center',
        }}
      >
        {children}
      </div>
    </th>
  );
};
